import { useMessaging } from "../util/customHooks/useMessaging/useMessaging";

export function PushNotifications() {
    useMessaging();
    return null;
}
